import React from 'react';

import guozhicha from '../../static/products/7_1.jpg';
import guozhichaTip from '../../static/products/7_2.jpg';
import youbenchaoqi from '../../static/products/3_1.jpg';
import youbenchaoqiTip from '../../static/products/3_2.jpg';
import lenglian from '../../static/products/8_2.jpg';
import lenglianTip from '../../static/products/8_1.jpg';
import wutangcha from '../../static/products/1_1.jpg';
import wutangchaTip from '../../static/products/1_2.jpg';
import chahanhan from '../../static/products/9_1.jpg';
import chahanhanTip from '../../static/products/9_2.jpg';
import duoduocha from '../../static/products/2_2.jpg';
import duoduochaTip from '../../static/products/2_1.jpg';
import dun from '../../static/products/10_2.jpg';
import dunTip from '../../static/products/10_1.jpg';
// import xueli from '../../static/products/11_1.jpg'
// import xueliTip from '../../static/products/11_2.jpg'
// import shuipingheng from '../../static/products/4_2.jpg'
// import shuipinghengTip from '../../static/products/4_1.jpg'
import huolishuipinheng from '../../static/products/5_1.jpg'
import huolishuipinhengTip from '../../static/products/5_2.png'
// import vcqipao from '../../static/products/6_2.jpg'
// import vcqipaoTip from '../../static/products/6_1.jpg'

import wishengsu from '../../static/products/13_2.jpg'
import wishengsuTip from '../../static/products/13_1.jpg'
// import duoduolilebao from '../../static/products/14_1.jpg'
// import duoduolilebaoTip from '../../static/products/14_2.jpg'
import wbbbao from '../../static/products/15_2.jpg'
import wbbbaoTip from '../../static/products/15_1.jpg'
import dun1_25 from '../../static/products/16_1.jpg'
import dun1_25Tip from '../../static/products/16_2.jpg'
import dun300 from '../../static/products/17_2.jpg'
import dun300Tip from '../../static/products/17_1.jpg'

import qingrucha from '../../static/products/12_2.jpg'
import qingruchaTip from '../../static/products/12_1.jpg'

import changwenguozhi from '../../static/products/18_2.jpg'
import changwenguozhiTip from '../../static/products/18_1.jpg'

import Product from '../Product';
import './index.sass';


//无糖茶、活力水平衡、多多、有气草本、果汁茶、冷链果汁、王爆爆pet、维生素水、轻乳茶、熟奶茶、茶憨憨、炖、常温果汁、王爆爆玻璃瓶、大炖、小炖
const productList = [
  {
    img: wutangcha,
    tipImg: wutangchaTip,
  },
  {
    img: huolishuipinheng,
    tipImg: huolishuipinhengTip,
  },
  {
    img: duoduocha,
    tipImg: duoduochaTip,
  },
  {
    img: youbenchaoqi,
    tipImg: youbenchaoqiTip,
  },
  {
    img: guozhicha,
    tipImg: guozhichaTip,
  },
  {
    img: lenglian,
    tipImg: lenglianTip,
  },
  {
    img: wbbbao,
    tipImg: wbbbaoTip,
  },
  {
    img: wishengsu,
    tipImg: wishengsuTip,
  },
  {
    img: qingrucha,
    tipImg: qingruchaTip,
  },
  {
    img: chahanhan,
    tipImg: chahanhanTip,
  },
  {
    img: dun,
    tipImg: dunTip,
  },
  {
    img: changwenguozhi,
    tipImg: changwenguozhiTip,
  },
  // {
  //   img: shuipingheng,
  //   tipImg: shuipinghengTip,
  // },
  // {
  //   img: vcqipao,
  //   tipImg: vcqipaoTip,
  // },
  // {
  //   img: duoduolilebao,
  //   tipImg: duoduolilebaoTip,
  // },
  {
    img: dun1_25,
    tipImg: dun1_25Tip,
  },
  {
    img: dun300,
    tipImg: dun300Tip,
  },
];

export default function ProductList({ ...props }) {
  return (
    <div className='holder'>
      {productList.map((product, i) => (
        <Product {...product} alignRight={!(i % 2)} key={i} />
      ))}
    </div>
  );
}
